module.exports = __webpack_public_path__ + "static/media/EmailBig.3bf37de6.svg";